import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

export interface HotelsParams {
  hotels?: string;
}

export function hotels(criteria: SearchCriteria | PartialSearchCriteria): HotelsParams {
  const { destination } = criteria;
  if (destination?.kind === 'hotels' && destination?.hotels?.length) {
    return { hotels: destination.hotels.map((hotel) => hotel.id).join('.') };
  }
  return {};
}
